/* Azure Club — tiras deslizables de producto */
(function () {
  var GAP = 16;

  function initSlider(viewport) {
    if (viewport.dataset.clubSliderReady === '1') return;
    viewport.dataset.clubSliderReady = '1';

    var track = viewport.querySelector('[data-club-slider]');
    if (!track) return;

    var prev = viewport.querySelector('[data-club-prev]');
    var next = viewport.querySelector('[data-club-next]');

    function maxScroll() {
      return track.scrollWidth - track.clientWidth;
    }

    function refresh() {
      var max = maxScroll();
      var scrollable = max > 8;
      var pos = track.scrollLeft;
      if (prev) prev.hidden = !scrollable || pos <= 8;
      if (next) next.hidden = !scrollable || pos >= max - 8;
      viewport.classList.toggle('is-scrollable', scrollable);
    }

    function stepWidth() {
      var card = track.querySelector('.club-product-card');
      if (!card) return track.clientWidth * 0.8;
      var w = card.getBoundingClientRect().width + GAP;
      var perView = Math.max(1, Math.round(track.clientWidth / w));
      return w * perView;
    }

    function go(direction) {
      track.scrollBy({ left: direction * stepWidth(), behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    track.addEventListener('scroll', refresh, { passive: true });
    window.addEventListener('resize', refresh);

    if (typeof ResizeObserver === 'function') {
      new ResizeObserver(refresh).observe(track);
    }

    refresh();
    // Las imágenes son lazy: recalculamos cuando ya tienen tamaño.
    setTimeout(refresh, 300);
    setTimeout(refresh, 1200);
    window.addEventListener('load', refresh);
  }

  function boot(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var nodes = root.querySelectorAll('.club-row-viewport');
    for (var i = 0; i < nodes.length; i++) initSlider(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
